import { render, staticRenderFns } from "./VideoBanner.vue?vue&type=template&id=56925d1d&"
import script from "./VideoBanner.vue?vue&type=script&lang=js&"
export * from "./VideoBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports